import { BleClient } from "@capacitor-community/bluetooth-le";
import {
  clearWifi,
  resetSequences,
  sendCommand,
  sendGetWifiList,
  sendGetWifiStatus,
  setWifi,
} from "@/features/ble/utils/sendCommand.ts";
import { AxiosInstance } from "axios";
import {
  getDeviceNotificationsStream,
  resetNotificationStreams,
} from "@/features/ble/utils/getDeviceNotificationsStream.tsx";
import { firstValueFrom, share, timeout } from "rxjs";
import { ref } from "vue";
import {
  removeBlePool,
  useStoredBlePool,
} from "@/features/ble/utils/localStorage.ts";

const clients = ref<Record<string, AxiosInstance>>({});

export const getBleClient = (
  deviceId: string,
  storedBlePool: ReturnType<typeof useStoredBlePool>
) => {
  if (!clients.value[deviceId]) {
    console.log("Creating ble client for device", deviceId);
    clients.value[deviceId] = {
      post: async (url: string, data: any) => {
        if (url === "/WaitCommand.php") {
          console.log("wait command skipped");
          return Promise.resolve({
            data: {
              response: {
                status: 0,
              },
            },
          });
        }

        try {
          console.log(`connecting to ${deviceId}`);
          try {
            await BleClient.connect(
              deviceId,
              () => {
                console.log(`${deviceId} disconnected`);
                resetNotificationStreams();
                resetSequences();
              },
              { timeout: 3000 }
            );
          } catch (e: any) {
            console.log(`Connection failed (${e.message}), retrying`);
            await BleClient.connect(deviceId, () => {
              console.log(`${deviceId} disconnected`);
              resetNotificationStreams();
              resetSequences();
            });
          }
          console.log(`connected to ${deviceId}`);
          const { responses$ } = getDeviceNotificationsStream(deviceId);
          console.log(`sending command ${url} to ${deviceId}`);
          if (url === "/ble:GetWifiList") {
            await sendGetWifiList(deviceId);
          } else if (url === "/ble:GetWifiStatus") {
            await sendGetWifiStatus(deviceId);
          } else if (url === "/ble:SetWifi") {
            await setWifi(deviceId, data);
          } else if (url === "/ble:ClearWifi") {
            await clearWifi(deviceId);
            return { data: { response: null } };
          } else {
            if (url !== "/GetBleToken.php") {
              if (!storedBlePool.value?.token) {
                throw new Error("Missing ble token");
              }

              data = {
                ...data,
                token: storedBlePool.value?.token,
              };
            }

            await sendCommand(deviceId, url, data);
          }
          console.log("waiting for resp");
          const resp = await firstValueFrom(
            responses$.pipe(share(), timeout(15000))
          );
          console.log("got resp");
          if (resp.status === "error") {
            console.log(resp);
            throw new Error(resp.detail);
          }
          return { data: resp };
        } catch (e: any) {
          if (e.message === "NOT AUTHORIZED") {
            removeBlePool(deviceId);
          }
          console.log("myerror", e);
          throw e;
        }
      },
    } as AxiosInstance;
  }

  return clients.value[deviceId];
};
